export const isIos = () => {
  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

export const handleGetLanguage = () => {
  let lang = navigator.language || navigator.userLanguage;
  lang = lang.substr(0, 2);
  switch (lang) {
    case "zh":
      lang = "cn";
      break;
    case "en":
      lang = "en";
      break;
    case "th":
      lang = "th";
      break;
    default:
      lang = "en";
  }
  return lang;
};
